import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import FallbackComponent from "../components/fallBackUI/FallBackUI";
import { AnimatePresence } from "framer-motion";
import NotFound from "../pages/NotFound/NotFound";

const Home = lazy(() => import("../pages/Home/Home"));
const About = lazy(() => import("../pages/About"));
const ServiceDetails = lazy(() => import("../pages/ServiceDetails"));
const ServiceList = lazy(() => import("../pages/ServiceList"));
const Contact = lazy(() => import("../pages/contact"));
const Testimonials = lazy(() => import("../pages/Testimonials"));
const Faq = lazy(() => import("../pages/Faq"));
const Projects = lazy(() => import("../pages/Projects"));
const ProjectDetail = lazy(() => import("../pages/ProjectDetail"));

const RoutesRoot = () => {
  return (
    <Router>
      <AnimatePresence>
        <Suspense fallback={<FallbackComponent />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="pages/about" element={<About />} />
            <Route
              path="/services/services-detail"
              element={<ServiceDetails />}
            />
            <Route path="/services/services" element={<ServiceList />} />
            <Route path="/home/contact" element={<Contact />} />
            <Route path="/pages/testimonials" element={<Testimonials />} />
            <Route path="/pages/faq" element={<Faq />} />
            <Route path="/pages/projects" element={<Projects />} />
            <Route path="/pages/project-detail" element={<ProjectDetail />} />
            <Route path="*" element={<NotFound />} /> 
          </Routes>
        </Suspense>
      </AnimatePresence>
    </Router>
  );
};

export default RoutesRoot;
